export const agents = {
  seo: {
    title: 'Devenez Agent Commercial Bistroo: 40% de Commission Récurrente',
    description: 'Vendez des logiciels de restauration nouvelle génération en NL, BE & DE. Gagnez 40% de commission récurrente avec une garantie de lancement de €1.500/mois.',
  },
  hero: {
    badge: 'Recrutement d\'agents en NL, BE & DE',
    title_1: 'Vendez une technologie de restauration qui se vend elle-même. Gagnez',
    title_em: '40% de commission récurrente',
    title_2: 'aussi longtemps que vos clients restent.',
    subtitle: 'Bistroo est la suite e-commerce nouvelle génération pour les restaurants quick-service : webshops, sites web, commande QR, kiosques et caisse. Vous apportez les restaurants. Nous faisons en sorte qu\'ils ne veuillent jamais partir. Et vous êtes payé chaque mois qu\'ils restent.',
    cta_primary: 'Devenir agent',
    cta_secondary: 'Voir l\'offre ↓',
    stats: [
      { value: '40%', label: 'commission récurrente' },
      { value: '€1.500/mo', label: 'garantie de lancement, 4 mois' },
      { value: 'Chaque semaine', label: 'versement pendant le lancement' },
      { value: '3', label: 'pays pour vendre' },
    ],
  },
  products: {
    kicker: 'Ce que vous vendez',
    heading: 'Des logiciels que les restaurateurs adorent vraiment.',
    lead: 'Bistroo équipe les restaurants quick-service d\'une suite de commande complète, plug-and-play: sans contrats à long terme, résiliable mensuellement, tarif d\'entrée avec un rendu premium. Cela facilite un oui rapide au comptoir.',
    items: [
      { icon: '🛍️', title: 'Webshop & Site Web', text: 'Webshops de commande à emporter et en livraison entièrement personnalisables, plus un site web propre au restaurant. Canal propre, clients propres, données propres.' },
      { icon: '📱', title: 'Commande QR à table', text: 'Les clients scannent, commandent et paient depuis leur table. Moins de déplacements, plus de chiffre d\'affaires par service.' },
      { icon: '🖥️', title: 'Kiosque & Caisse', text: 'Kiosques libre-service et module de caisse conçu pour le quick-service. Une suite, un abonnement, géré dans le Bistroo Manager intuitif.' },
    ],
  },
  deal: {
    kicker: 'L\'offre',
    heading: 'Construisez un revenu qui croît. Pas une prime unique.',
    lead: 'La plupart des deals commerciaux paient une seule fois. Nous vous payons 40% des revenus récurrents de chaque restaurant que vous intégrez, chaque mois qu\'il reste chez Bistroo. Intégrez une fois, gagnez pour toujours.',
    commission: {
      title: 'Commission récurrente',
      value: '40%',
      text: 'Sur les revenus récurrents de chaque client professionnel que vous intégrez, aussi longtemps qu\'il reste un partenaire Bistroo actif. Votre portefeuille grandit et vos revenus mensuels grandissent avec lui.',
    },
    retainer: {
      pill: 'Garantie de lancement',
      title: 'Vos 4 premiers mois, sans risque.',
      value: '€1.500/mo',
      text: 'La commission récurrente prend du temps à se construire, nous comblons donc ce fossé. Intégrez 8 nouveaux clients professionnels en un mois et nous vous garantissons €1.500 ce mois-là, versé chaque semaine : convertissez 2 clients professionnels en une semaine et vous êtes payé cette semaine.',
    },
  },
  ramp: {
    kicker: 'Comment fonctionne la montée en puissance',
    heading: 'De la rémunération garantie à la commission autonome en 4 mois.',
    lead: 'Maintenez le rythme de 8 clients professionnels intégrés par mois et les chiffres font le reste : après le mois 4, vous détenez un portefeuille de 32+ restaurants générant au moins €1.440 de commission mensuelle, et cela continue de croître avec chaque client que vous ajoutez.',
    table_headers: ['Mois', 'Objectif (nouveaux clients)', 'Total portefeuille', 'Versement garanti'],
    table_rows: [
      ['1', '8', '8', '€1.500 (versements hebdomadaires)'],
      ['2', '8', '16', '€1.500 (versements hebdomadaires)'],
      ['3', '8', '24', '€1.500 (versements hebdomadaires)'],
      ['4', '8', '32', '€1.500 (versements hebdomadaires)'],
      ['Mois 5+', 'Votre rythme', '32+', '€1.440+ /mois à 40% de commission récurrente'],
    ],
    note: 'Conditions de la rémunération de lancement : durée maximale 4 mois. La garantie mensuelle s\'applique lorsque vous intégrez 8 nouveaux clients professionnels dans ce mois ; le versement hebdomadaire s\'applique dans les semaines où vous convertissez 2 clients professionnels. Le montant de €1.440+ est la commission mensuelle minimale attendue pour un portefeuille de 32 clients. Les gains réels dépendent des modules utilisés par vos clients et augmentent avec votre portefeuille. Les conditions générales s\'appliquent ; le contrat d\'agent complet est communiqué lors de l\'onboarding.',
    checks: [
      { strong: 'Pas de plafond sur vos gains.', text: '32 clients est le plancher, pas le plafond. Continuez à intégrer et vos revenus récurrents continuent de s\'accumuler.' },
      { strong: 'Vous vendez, nous livrons.', text: 'Notre équipe gère la configuration, le design et le support. Vos clients sont entre de bonnes mains et votre portefeuille reste sain.' },
      { strong: 'Un produit honnête à défendre.', text: 'Abonnements mensuels, sans engagement. Les restaurants restent parce qu\'ils le veulent. Et c\'est précisément pourquoi la commission récurrente fonctionne.' },
    ],
  },
  steps: {
    kicker: 'Démarrer',
    heading: 'De l\'inscription au premier versement en quatre étapes.',
    items: [
      { title: 'S\'inscrire', text: 'Remplissez le formulaire d\'inscription (2 minutes). Parlez-nous de votre réseau et de votre région.' },
      { title: 'Intro & onboarding', text: 'Un appel personnel, une formation produit et votre kit d\'agent : environnement de démo, tarifs et matériels.' },
      { title: 'Commencer à vendre', text: 'Arpentez les rues, activez votre réseau. Nous soutenons chaque deal avec une mise en place rapide pour que vos clients soient opérationnels rapidement.' },
      { title: 'Être payé chaque semaine', text: 'Convertissez 2 clients professionnels en une semaine et votre versement de lancement arrive cette même semaine.' },
    ],
  },
  who: {
    kicker: 'Qui nous recherchons',
    heading: 'Des chasseurs avec l\'hôtellerie dans le sang.',
    items: [
      { icon: '🤝', title: 'Connecté', text: 'Vous connaissez des restaurateurs, ou vous savez comment les approcher. Un réseau dans le quick-service, la vente à emporter ou la livraison est une longueur d\'avance.' },
      { icon: '⚡', title: 'Autonome', text: 'Vous définissez votre propre rythme et gérez votre propre pipeline. Nous vous fournissons les outils, la formation et le soutien. Vous apportez la motivation.' },
      { icon: '🌍', title: 'Basé en NL, BE ou DE', text: 'Nous sommes actifs aux Pays-Bas et en Belgique, et lançons en Allemagne en 2026. Les premiers agents choisissent leur territoire en premier.' },
    ],
  },
  cta: {
    heading: 'Prêt à construire votre portefeuille ?',
    text: 'Inscrivez-vous en 2 minutes. Nous vous contacterons dans les deux jours ouvrables pour planifier votre appel d\'introduction.',
    button: 'S\'inscrire via le formulaire',
    small: 'Les conditions générales s\'appliquent. Le contrat d\'agent complet et les conditions de commission sont formalisés lors de l\'onboarding.',
  },
}
